import { render, staticRenderFns } from "./RegisterVisit.vue?vue&type=template&id=544368f6&scoped=true"
import script from "./RegisterVisit.vue?vue&type=script&lang=js"
export * from "./RegisterVisit.vue?vue&type=script&lang=js"
import style0 from "./RegisterVisit.vue?vue&type=style&index=0&id=544368f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544368f6",
  null
  
)

export default component.exports